export const version = "hdnode/5.0.7";
//# sourceMappingURL=_version.js.map